import Stepper from "ds/components/Stepper";
import StepperHeader from "ds/components/Stepper/Header";
import StepperStep from "ds/components/Stepper/Step";
import StepperStepsGroup from "ds/components/Stepper/StepsGroup";
import useTypedContext from "hooks/useTypedContext";

import { API_KEY_CREATION_WIZARD_NAV_STEPS } from "../constants";
import { ApiKeyCreateWizardContext } from "../context";

const ApiKeyCreateStepper = () => {
  const { currentStep, setCurrentStep } = useTypedContext(ApiKeyCreateWizardContext);

  return (
    <Stepper>
      <StepperHeader>Follow the steps</StepperHeader>
      <StepperStepsGroup>
        {API_KEY_CREATION_WIZARD_NAV_STEPS.map((item, index) => (
          <StepperStep
            key={item.step}
            active={item.step === currentStep}
            onClick={index < currentStep ? () => setCurrentStep(item.step) : undefined}
            disabled={index > currentStep}
          >
            {item.name}
          </StepperStep>
        ))}
      </StepperStepsGroup>
    </Stepper>
  );
};

export default ApiKeyCreateStepper;
